import Axios from '../../networking/intraceptor';

const unwrapData = (response) => response?.data?.data ?? response?.data;

const normalizeError = (error) => {
	const message = error?.response?.data?.error
		|| error?.response?.data?.message
		|| error?.message
		|| 'Support chat request failed.';

	const normalized = new Error(message);
	normalized.status = error?.response?.status;
	normalized.body = error?.response?.data;
	return normalized;
};

const request = async (callback) => {
	try {
		const response = await callback();
		return unwrapData(response);
	} catch (error) {
		throw normalizeError(error);
	}
};

const toEnrollmentPayload = (payload) => ({
	pharmacy_name: payload.pharmacyName,
	contact_email: payload.contactEmail,
	contact_phone: payload.contactPhone,
	address: payload.address,
	product: 'oatrx',
});

const getAttachmentFiles = (attachments = []) => attachments
	.map((attachment) => attachment?.file)
	.filter(Boolean);

const hasAttachmentFiles = (attachments = []) => getAttachmentFiles(attachments).length > 0;

const toThreadFormData = (payload) => {
	const formData = new FormData();

	if (payload.title) {
		formData.append('title', payload.title);
	}

	if (payload.message) {
		formData.append('message', payload.message);
	}

	if (payload.sender_name) {
		formData.append('sender_name', payload.sender_name);
	}

	getAttachmentFiles(payload.attachments).forEach((file) => {
		formData.append('attachments[]', file);
	});

	return formData;
};

export const supportChatApi = {
	getStatus: () => request(() => Axios.get('pharmacy-support/status')),

	enroll: (payload) => request(() => Axios.post('pharmacy-support/enroll', toEnrollmentPayload(payload))),

	getMe: () => request(() => Axios.get('pharmacy-support/me')),

	getUnreadCount: () => request(() => Axios.get('pharmacy-support/unread-count')),

	getThreads: () => request(() => Axios.get('pharmacy-support/threads')),

	createThread: (payload) => request(() => {
		if (hasAttachmentFiles(payload.attachments)) {
			return Axios.post('pharmacy-support/threads', toThreadFormData(payload));
		}

		return Axios.post('pharmacy-support/threads', {
			title: payload.title,
			message: payload.message,
			sender_name: payload.sender_name,
		});
	}),

	getMessages: (threadId) => request(() => Axios.get(`pharmacy-support/threads/${encodeURIComponent(threadId)}/messages`)),

	markThreadRead: (threadId) => request(() => Axios.post(`pharmacy-support/threads/${encodeURIComponent(threadId)}/read`)),

	sendMessage: (threadId, payload) => request(() => {
		if (hasAttachmentFiles(payload.attachments)) {
			return Axios.post(`pharmacy-support/threads/${encodeURIComponent(threadId)}/messages`, toThreadFormData(payload));
		}

		return Axios.post(`pharmacy-support/threads/${encodeURIComponent(threadId)}/messages`, {
			message: payload.message,
			sender_name: payload.sender_name,
		});
	}),

	getBroadcasts: () => request(() => Axios.get('pharmacy-support/broadcasts')),
};
